module.exports = __webpack_public_path__ + "media/images/proof_links/vk-d6dbb5e1bb598468e872bc59a9862181.svg";